import React from 'react';
import { ButtonGroup as BSButtonGroup } from "react-bootstrap";

export interface ButtonGroupProps extends BSButtonGroup.ButtonGroupProps {

}

export const ButtonGroup: React.FC<ButtonGroupProps> = (props) => {
   return (
      <BSButtonGroup {...props}>
         {props.children}
      </BSButtonGroup>
   )
}

(ButtonGroup as any).displayName = 'ButtonGroup';